import {createFileRoute} from "@tanstack/react-router";
import {getCustomerOfferQueryOptions} from "@project/application/sales/customer-offers";
import {offerEditorWorkspaceMessages} from "@project/components/semantic-adapters/sales/offers/offer-editor-workspace.messages";
import {OfferEditorPage} from "./-page/offer-editor.page";
import {OfferEditorPending} from "./-page/offer-editor.pending";

export const Route = createFileRoute("/_app/sales/offers/editor/$customerOfferId/")({
  component: RouteComponent,
  loader: ({context: {queryClient}, params}) =>
    queryClient.ensureQueryData(getCustomerOfferQueryOptions(params.customerOfferId)),
  pendingComponent: OfferEditorPending,
  staticData: {
    meta: {
      labelDescriptor: offerEditorWorkspaceMessages.editor,
      breadcrumbs: {
        getParent: (params, data) =>
          data &&
          typeof data === "object" &&
          "customerOfferId" in data &&
          typeof data.customerOfferId === "string" &&
          data.customerOfferId.toLowerCase() === params.customerOfferId?.toLowerCase() &&
          "name" in data &&
          typeof data.name === "string"
            ? {
                label: data.name,
                pathname: "/sales/offers/" + encodeURIComponent(data.customerOfferId),
              }
            : null,
      },
    },
  },
});
function RouteComponent() {
  const {customerOfferId} = Route.useParams();
  return <OfferEditorPage offerId={customerOfferId} />;
}
